import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOvInvestigation } from "../models/overage";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";
import { getHeaderActionType } from "../helpers";

/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const SaveOrSubmitInvestigationAPI = async (
  params: IOvInvestigation,
  osdNumber: number,
  action: string,
) => {
  try {
    const headers = getTrackingHeadersMap(ApiType.SAVE_OR_SUBMIT_INVESTIGATION)
    headers["OSD-Action-Type"] = getHeaderActionType(action);
    headers["OSD-Exception-Type"] = params?.osdType ?? "";

    const response = await axios.post(`${getUrl(ApiType.SAVE_OR_SUBMIT_INVESTIGATION)}/${osdNumber}/investigation/${action}`, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.saveOrSubmitAPIError, { badRequestOrder: "errorsFirst" });
  }
};
